import React from 'react'

import { Stack } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import { TrackedChangeFilter } from '#components/ChangeTracking/Panel'
import { ILoadedScript } from '#state'

import { useTrackedChangeThread } from './hooks'
import { ThreadBase } from './Thread'

export const TrackedChangeThreadList = observer<{
  script: ILoadedScript
  filter: TrackedChangeFilter
}>(({ script, filter }) => {
  const { createActionsFor, isSelected } = useTrackedChangeThread(script)

  const changes =
    filter === 'open'
      ? script.changeTrackingData.proposedChanges
      : script.changeTrackingData.reviewedChanges

  return (
    <Stack p={10}>
      {changes.map((change) => {
        const actions = createActionsFor(change.id)

        return (
          <ThreadBase
            key={change.id}
            selected={isSelected(change.id)}
            thread={change}
            onUpdateReply={actions.onUpdateReply}
            onDeleteReply={actions.onDeleteReply}
            script={script}
          />
        )
      })}
    </Stack>
  )
})
